// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__1K12d","title":"Navbar_title__2V3Ji","menu":"Navbar_menu__3mGk_","menuLink":"Navbar_menuLink__1UQrF"};